import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { defineStyles, theme } from '../theme';
import { RemoveFilterButton } from './buttons/RemoveFilterButton';
import { ConditionForm } from './ConditionForm';
const styles = defineStyles({
    root: {
        width: 'fit-content',
        display: 'flex',
        py: 0.25,
        px: 1,
        '&.MuiGrid-root': {
            alignItems: 'center',
            width: '100%',
        },
    },
    conditionForm: {
        mx: 0.25,
        width: '100%',
    },
    disabled: {
        backgroundColor: theme.vars.palette.grey[300],
    },
    removeButton: {
        m: 0,
        ml: 1,
        p: 0,
        display: 'flex',
        justifyContent: 'center',
        color: theme.vars.palette.grey[700],
    },
});
export function FilterOrCondition({ fixed, andConditionsIndex, orConditionsIndex, filterColumns, disabledOperators, showRemoveButton = true, onDeleteClick, enableAutocomplete, sx, }) {
    return (_jsxs(Grid, { item: true, sx: { ...styles.root, ...(fixed && styles.disabled), ...sx }, children: [_jsx(Box, { sx: styles.conditionForm, children: _jsx(ConditionForm, { disabled: fixed, andConditionsIndex: andConditionsIndex, orConditionsIndex: orConditionsIndex, filterColumns: filterColumns, disabledOperators: disabledOperators, enableAutocomplete: enableAutocomplete }) }), !fixed && showRemoveButton && (_jsx(RemoveFilterButton, { disabled: fixed, onClick: () => onDeleteClick(), sx: styles.removeButton }))] }));
}
//# sourceMappingURL=FilterOrCondition.js.map